import React, { useEffect } from "react";
import { Text } from "@fluentui/react";
import { useMsal } from "@azure/msal-react";

export const LogoutPage: React.FC = () => {

    const msal = useMsal();

    useEffect(() => {
        msal.instance.logoutRedirect({
            onRedirectNavigate: () => false
        });
    }, []);

    return <Text>Logging out...</Text>
};
